import { z } from 'zod';
import { IssueKind } from './issue.js';
import { TaskTypeColor } from './project.js';
/**
 * Loại issue do dự án tự quản — APM-ITYPE-a, docs/plan-issue-types.md.
 *
 * Tên và số loại là của PM; **cách xử lý** (`baseKind`) chỉ có ba (`IssueKind`),
 * vì hành vi gắn với nó: yêu cầu có ảnh hưởng 1, sự cố liên kết vào nguyên nhân
 * gốc, phân loại bảo trì mặc định, OKR. `issue.kind` luôn bằng `baseKind` của loại.
 *
 * Màu dùng chung bảng 30 màu của loại việc — một bảng màu cho mọi thẻ loại.
 */
/** Ba loại mỗi dự án mới có sẵn. Tên là **dữ liệu** (PM đổi được), không qua i18n. */
export const DEFAULT_ISSUE_TYPES = [
    { name: 'Sự cố', baseKind: 'incident' },
    { name: 'Yêu cầu', baseKind: 'request' },
    { name: 'Nguyên nhân gốc', baseKind: 'problem' },
];
export const IssueTypeItem = z.object({
    id: z.uuid(),
    name: z.string(),
    color: TaskTypeColor.nullable(),
    baseKind: IssueKind,
    position: z.number().int().nonnegative(),
    /** Số issue (kể cả đã đóng, trừ đã xoá) đang mang loại này — quyết định hộp xoá. */
    issueCount: z.number().int().nonnegative(),
});
/** `.trim()` **trước** `.min()` — chuỗi toàn dấu cách không lọt qua (bẫy APM-PERF2-o). */
const IssueTypeName = z.string().trim().min(1, 'Tên loại là bắt buộc').max(60);
export const CreateIssueTypeInput = z.object({
    name: IssueTypeName,
    color: TaskTypeColor.nullable().optional(),
    baseKind: IssueKind,
});
export const UpdateIssueTypeInput = z
    .object({
    name: IssueTypeName.optional(),
    color: TaskTypeColor.nullable().optional(),
    baseKind: IssueKind.optional(),
})
    .refine((input) => Object.values(input).some((value) => value !== undefined), {
    message: 'Không có gì để sửa',
});
/** Xoá loại đang có issue ⇒ bắt buộc loại thay thế, **cùng cách xử lý**, cùng dự án. */
export const DeleteIssueTypeQuery = z.object({
    replacementId: z.uuid().optional(),
});
//# sourceMappingURL=issue-type.js.map